// src/hooks/useBrowserCompatibility.js

import { useMemo } from "react";
import { detectBrowserContext } from "../utils/compatibility/browserDetection";

/**
 * DI-0076 browser compatibility hook.
 * Traceability: F005-DI-0077
 */
export default function useBrowserCompatibility() {
  return useMemo(() => detectBrowserContext(), []);
}
